import api from './api';

export interface WorldCheckEntityListItem {
	id: string;
	full_name: string;
	entity_type?: string;
	country?: string;
	date_of_birth?: string | null;
	place_of_birth?: string | null;
	aliases?: any[] | null;
	identifiers?: any[] | null;
	categories?: any[] | null;
	sources?: any[] | null;
	risk_level?: string | null;
	pep?: boolean | null;
	sanctioned?: boolean | null;
	listing_details?: string | null;
	last_seen?: string | null;
	created_at?: string | null;
	updated_at?: string | null;
}

export interface UploadResponse {
	inserted: number;
	duplicates_skipped: number;
	errors: number;
	total_processed: number;
}

export interface ListParams {
	skip?: number;
	limit?: number;
	search?: string;
	country?: string;
	entity_type?: string;
	risk_level?: string;
	pep?: boolean;
	sanctioned?: boolean;
}

export interface ListResponse {
	total: number;
	skip: number;
	limit: number;
	entities: WorldCheckEntityListItem[];
}

class WorldCheckService {
	async upload(file: File): Promise<UploadResponse> {
		const form = new FormData();
		form.append('file', file);
		const response = await api.post('/worldcheck/upload', form, {
			headers: { 'Content-Type': 'multipart/form-data' },
			timeout: 120000, // 2 minutes for large files
		});
		return response.data;
	}

	async list(params: ListParams = {}): Promise<ListResponse> {
		const query = new URLSearchParams();
		Object.entries(params).forEach(([key, value]) => {
			if (value !== undefined && value !== null && value !== '') {
				query.append(key, String(value));
			}
		});
		const qs = query.toString();
		const response = await api.get(`/worldcheck/entities${qs ? `?${qs}` : ''}`);
		return response.data;
	}
}

export const worldcheckService = new WorldCheckService();



